import { render } from "./droppedCard.vue?vue&type=template&id=264c8e4a&scoped=true"
import script from "./droppedCard.vue?vue&type=script&lang=js"
export * from "./droppedCard.vue?vue&type=script&lang=js"

import "./droppedCard.vue?vue&type=style&index=0&id=264c8e4a&lang=scss&scoped=true"

import exportComponent from "/home/jenkins/workspace/qixiao_410_6413_沙箱云前端生产环境/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-264c8e4a"]])

export default __exports__